import { useEffect, useState } from 'react';
import { Shield, X } from 'lucide-react';

/**
 * Banner shown across the top of the app when the current session was opened
 * via the platform owner's "View as" feature. Reminds the platform owner they
 * are seeing the app AS a customer, and gives a one-click exit (clears the
 * impersonation token from localStorage and redirects to /login).
 */
export function ImpersonationBanner() {
  const [info, setInfo] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    try {
      const raw = localStorage.getItem('impersonation_banner');
      if (raw) setInfo(JSON.parse(raw));
    } catch (_e) { /* ignore */ }
    const tick = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(tick);
  }, []);

  if (!info) return null;

  const minsLeft = Math.max(0, Math.floor((info.expires_at - now) / 60000));

  const exit = () => {
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('impersonation_banner');
    } catch (_e) { /* ignore */ }
    window.location.href = '/login';
  };

  return (
    <div
      className="bg-brand-signature text-brand-signature-strong px-4 py-2 flex items-center justify-between gap-3 border-b-2 border-brand-signature-hover"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2 text-sm">
        <Shield className="w-4 h-4 flex-shrink-0" />
        <span className="font-semibold">Support session active</span>
        <span className="opacity-80">
          — viewing as <strong>{info.target}</strong>
          {info.org && ` (${info.org})`}
          {minsLeft > 0 ? ` · ${minsLeft} min left` : ' · expired'}
        </span>
      </div>
      <button
        onClick={exit}
        className="text-xs font-bold uppercase tracking-wide px-2.5 py-1 rounded bg-brand-signature-strong text-white hover:opacity-90 flex items-center gap-1"
        data-testid="impersonation-exit-btn"
      >
        <X className="w-3 h-3" />
        Exit
      </button>
    </div>
  );
}
